// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__21xDU","header":"ReportDetails_header__OvPB_","title":"ReportDetails_title__1J6ww","left":"ReportDetails_left__3OE8K"};